import React, { useEffect, useState } from "react";
import "./SingleCampaign.css";
import { useLocation, useNavigate } from "react-router-dom";
import getSingleCampaign from "../Controller/getSingleCampaign";
import getSingleProperty from "../Controller/getSingleProperty";
import PropertiesContent from "../../Properties/PropertiesContent/PropertiesContent";
import getAllLeadsInCampaign from "../Controller/getAllLeadsInCampaign";
import getSingleTemplate from "../Controller/getSingleTemplate";
import Preview from "../preview/Preview";
import ContentLoader from "../../../components/Common/ContentLoader/ContentLoader";
import UserListCard from "../../../components/UserListCard/UserListCard";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import OutboxIcon from "@mui/icons-material/Outbox";
import storeDataToMail from "../Controller/storeDataToMail";
import { updateCampaign } from "../Controller/storeCampaign";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";
const SingleCampaign = () => {
  const [campaign, setCampaign] = useState();
  const [property, setProperty] = useState();
  const [campaignLeads, setCampaignLeads] = useState();
  const [template, setTemplate] = useState();
  const [templateHtml, setTemplateHtml] = useState();
  const [user, setUser] = useState({});

  const [requestingData, setRequestingData] = useState(true);
  const [statusArray, setStatusArray] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const [modalStatus, setModalStatus] = useState(false);
  const [BDetails, setBDetails] = useState({});
  useEffect(() => {
    async function fetchData() {
      const clientDocument = await doc(
        db,
        "clients",
        getLocalStorageItem("bid")
      );
      const clientSnapshot = await getDoc(clientDocument);
      const client = { id: clientSnapshot.id, ...clientSnapshot.data() };
      setBDetails(client);

      const usersDocument = await doc(db, "users", client.uid);
      const usersSnapshot = await getDoc(usersDocument);
      const users = { id: usersSnapshot.id, ...usersSnapshot.data() };

      console.log("users", users);
      setUser(users);
    }
    fetchData();
  }, []);
  let isMarketing = true;

  let location = useLocation();
  const navigate = useNavigate();
  const cId = location.pathname.split("/").pop();
  useEffect(() => {
    const fetchData = async () => {
      // Get campaign
      let resp = await getSingleCampaign(cId);

      // Get  campaign all leads
      let status = resp?.statusArray;

      console.log("Temp Array, ", status);
      let cLeads = await getAllLeadsInCampaign(resp?.leads);

      //  Get template
      let tempTemplate = await getSingleTemplate(resp?.template);

      // Get campaign property
      let cProperty = await getSingleProperty(resp?.property);
      cProperty = { ...cProperty, id: cId };
      setTemplateHtml(resp?.templateHtml);
      setProperty(cProperty);
      setTemplate(tempTemplate);
      setCampaignLeads(cLeads);
      setCampaign(resp);
      setStatusArray(status);
      setRequestingData(false);
    };
    fetchData();
  }, [refresh]);

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <div className="global-body-container">
      <div className="single-campaign-details">
        <div className="campaign-details-header">
          <h2 className="custom-heading">Marketing Details</h2>
          <button
            className="add-marketing-button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/user/marketing/campaign/reschedule/${cId}`);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 17V7"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M7 12H17"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            Duplicate Campaign
          </button>
        </div>
        {!requestingData && (
          <>
            <div className="campaign-details">
              <div className="left">
                <div className="campaign-title-container">
                  <div>
                    <h2 className="custom-heading campaign-heading">
                      {campaign?.campaignTitle}
                    </h2>
                    <h4 className="campaign-date mt-2">
                      <span
                        style={{
                          color: "black",
                          fontWeight: 600,
                          fontSize: "17px",
                        }}
                      >
                        Scheduled on:{" "}
                      </span>
                      {campaign?.createdAt
                        .toDate()
                        .toLocaleDateString(undefined, {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                    </h4>
                  </div>
                </div>
                <div className="template-preview-container">
                  <span
                    onClick={() => {
                      setModalStatus(true);
                    }}
                  >
                    Email preview
                  </span>
                </div>
              </div>
              <div className="right">
                <div className="single-campaign-property">
                  {property !== undefined && (
                    <PropertiesContent isAddDeal={true} property={property} />
                  )}
                </div>
              </div>
            </div>

            <div className="campaign-client-listing">
              {/* <div>
                <h3 className="client-listing-label">Clients:</h3>
              </div> */}
              {isMobile ? (
                campaignLeads &&
                campaignLeads.map((lead, index) => {
                  return (
                    <UserListCard
                      name={lead.name}
                      date={lead?.createdAt?.toDate()?.toLocaleString("en-GB", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                      phone={lead.phone}
                      email={lead.email}
                      isMarketing={isMarketing}
                      statusArray={statusArray}
                      index={index}
                      className="edit-delete-svg"
                      onClick={async () => {
                        let result = await storeDataToMail(
                          lead.email,
                          BDetails.email == null ||
                            BDetails.email == "" ||
                            BDetails.email == undefined
                            ? "flutter.logicworms@gmail.com"
                            : BDetails.email,
                          BDetails.businessName == null ||
                            BDetails.businessName == "" ||
                            BDetails.businessName == undefined
                            ? "Landbook"
                            : BDetails.businessName
                        );
                        if (result === false) {
                          statusArray[index] = false;
                        } else {
                          statusArray[index] = true;
                        }
                        await updateCampaign(cId, statusArray);
                        setRefresh(!refresh);
                      }}
                      // cnic={lead.cnic}
                      // address={lead.address}
                      // onEdit={() => {
                      //   handleOpen("update", lead.id);
                      // }}
                      // onClick={() =>
                      //   navigate(`/user/leads/details/${lead.id}`)
                      // }
                      // onDelete={() => {
                      //   handleOpenDeleteDialog(lead.id);
                      // }}
                    />
                  );
                })
              ) : (
                <div
                  className="table-responsive table-stripedd table-hoverr mt-2 
        "
                >
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th scope="col">
                          <span
                            className="lead-name"
                            style={{
                              fontWeight: 500,
                            }}
                          >
                            Name
                          </span>
                        </th>
                        <th scope="col">
                          <span
                            style={{
                              fontWeight: 500,
                            }}
                          >
                            Mobile
                          </span>
                        </th>
                        <th scope="col">
                          <span
                            style={{
                              fontWeight: 500,
                            }}
                          >
                            Address
                          </span>
                        </th>
                        <th scope="col">
                          <span
                            style={{
                              fontWeight: 500,
                            }}
                          >
                            Email
                          </span>
                        </th>

                        <th scope="col" className="header-action-container">
                          <span
                            className="header-action-title"
                            style={{
                              fontWeight: 500,
                            }}
                          >
                            Action
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {campaignLeads &&
                        campaignLeads.map((lead, index) => {
                          console.log("Temp Array, Index ", index);
                          return (
                            <tr>
                              <th
                                scope="row"
                                style={{
                                  fontWeight: 500,
                                }}
                              >
                                {lead.name}

                                <br />
                                <div className="alignment">
                                  <small className="add-on">Added on:</small>

                                  <small>
                                    {lead?.createdAt
                                      ?.toDate()
                                      ?.toLocaleString("en-GB", {
                                        year: "numeric",
                                        month: "short",
                                        day: "numeric",
                                      })}
                                  </small>
                                </div>
                              </th>
                              <td>{lead.phone}</td>
                              <td className="text-truncate">
                                {lead.address ? lead.address : "-------"}
                              </td>
                              <td>{lead.email ? lead.email : "-------"}</td>

                              <td>
                                {statusArray[index] === true ? (
                                  <div className="edit-delete-svg">
                                    <span className="delete-svg-icon">
                                      <MarkEmailReadIcon
                                        style={{ color: "green" }}
                                      />
                                    </span>
                                  </div>
                                ) : (
                                  lead.email && (
                                    <div
                                      className="edit-delete-svg"
                                      onClick={async () => {
                                        let result = await storeDataToMail(
                                          lead.email,
                                          user.email === ""
                                            ? "flutter.logicworms@gmail.com"
                                            : user.email,

                                          BDetails.businessName === ""
                                            ? "Landbook"
                                            : BDetails.businessName,
                                          property?.propertyTitle +
                                            ", " +
                                            property?.propertySubType,
                                          property?.availableForRent === true
                                            ? "Rent"
                                            : "Sell",
                                          templateHtml
                                        );
                                        if (result === false) {
                                          statusArray[index] = false;
                                        } else {
                                          statusArray[index] = true;
                                        }
                                        await updateCampaign(cId, statusArray);
                                        setRefresh(!refresh);
                                      }}
                                    >
                                      <span className="delete-svg-icon">
                                        <OutboxIcon style={{ color: "red" }} />
                                      </span>
                                    </div>
                                  )
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
        {requestingData && <ContentLoader />}
      </div>
      {template && (
        <Preview
          {...{
            modalStatus,
            setModalStatus,
            template,
            property,
          }}
        />
      )}
    </div>
  );
};

export default SingleCampaign;
